import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MDBDatePickerComponent, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { BodegaService } from 'src/app/services/bodega.service';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { DireccionService } from 'src/app/services/direccion.service';
import { DocumentoService, IFechaVencimientoQueryParams } from 'src/app/services/documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { VendedorRubroClienteService } from 'src/app/services/vendedor-rubro-cliente.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalDocsReferenciaComponent } from 'src/app/views/shared/modal-docs-referencia/modal-docs-referencia.component';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';

@Component({
  selector: 'app-nota-venta-cabecera',
  templateUrl: './nota-venta-cabecera.component.html',
  styleUrls: ['./nota-venta-cabecera.component.scss'],
  providers: [SecurityService],
})
export class NotaVentaCabeceraComponent implements OnInit {
  @Input() permiteUnidadNegocio: boolean = false;
  @Input() optionsUnidadesDeNegocio: unidad_negocio[] = [];

  @Output() onHeaderDataChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onApplyGlobalDiscount: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalDocsReferenciaComponent, { static: true }) modalDocsReferencias: ModalDocsReferenciaComponent;
  @ViewChild('datePickerFechaVencimiento', { static: true }) datePickerFechaVencimiento: MDBDatePickerComponent;

  // Form
  formHeader: FormGroup;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  enableContent: boolean = true;
  cliente: any = null;
  sucursal: any = null;

  optionsBodega: Array<any> = [];
  optionsSucursal: Array<any> = [];
  optionsVendedor: Array<any> = [];
  // optionsListaPrecio: Array<any> = [];
  optionsCondicionPago: Array<any> = [];
  mode: string = 'ADD';
  CountListDocRef: number = 0;
  documentRef: Array<any> = [];
  // Utils
  private log: any;
  nvFolio: number = 0;
  NvCabecera: any = null;
  direccion_cliente: any = null;
  facturasAsociadas: number[] = []; // Array de facturas asociadas a la nota de venta
  mostrarFacturasPopover: boolean = false; // Control para mostrar/ocultar el popover de facturas

  descuentoDirty: boolean = false;
  private syncingDescuento: boolean = false;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private bodegaServ: BodegaService,
    private clienteProveedorService: ClienteProveedorService,
    private condicionPagoService: CondicionPagoService,
    private clog: ConsoleService,
    private rutService: RutService,
    private direccionService: DireccionService,
    private vendedorRubroClienteService: VendedorRubroClienteService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService,
    private documentoService: DocumentoService
  ) {
    this.log = this.clog.log('NOTA-VENTA-CABECERA');
  }

  get formValue() {
    return this.formHeader.getRawValue();
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.loadBodegas();
    this.loadCondicionPago();

    this.createForms();
    // this.formHeader.get('descuento').disable();
    this.formChangesSubscriptions();
  }

  loadBodegas() {
    this.bodegaServ.GetBodegas(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsBodega = registros.map((bodega) => ({
        value: bodega.codigo,
        label: bodega.nombre,
        sucursal_codigo: bodega.sucursal_codigo,
        codigo: bodega.codigo,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega);
    });
  }

  loadCondicionPago() {
    this.condicionPagoService.Get(this.rutEmpresa, this.sucursalEmpresa, ({ registros }) => {
      this.optionsCondicionPago = registros.map((condicionPago) => ({
        value: condicionPago.codigo,
        label: condicionPago.descripcion,
        ...condicionPago,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('condicionPago'), this.optionsCondicionPago);
    });
  }
  //ABRIR MODAL TABLA DE DOCS. REFERENCIA
  abrirModalDocsReferencia(mode) {
    //enviar fecha que viene en rut cliente
    const fechaDoc = this.formValue.fechaDoc;
    this.modalDocsReferencias.showWhitConfig(fechaDoc, mode);
  }

  //MOSTRAR CONTADOR DE DOCS REFERENCIAS
  getCountListDocRef($event) {
    this.CountListDocRef = $event.length;
    this.documentRef = $event;
  }

  private createForms() {
    const now = this.datesService.CurrentDateToShortTimeString();
    this.formHeader = this.fb.group({
      fechaDoc: [now, [Validators.required]],
      fechaVenc: [null, [Validators.required]],
      bodega: [null, [Validators.required]],
      unidad_negocio_codigo: [null, [Validators.required]],
      rutCliente: [null, [Validators.required]],
      sucursal: [null, [Validators.required]],
      condicionPago: [null, [Validators.required]],
      oc: [0, [Validators.min(0)]],
      descuentoPorcentaje: [null, [Validators.min(0), Validators.max(99.9999)]],
      descuentoMonto: [null, [Validators.min(0)]],
      vendedor: [null, [Validators.required]],
      listaPrecios: [null, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente);
        this.modalSeleccionarCliente.cleanLast();
      });

    this.formHeader.get('sucursal').valueChanges.subscribe((sucursal) => {
      this.handleDireccionChange(sucursal);
    });

    this.formHeader.get('fechaDoc').valueChanges.subscribe((value) => {
      this.fetchFechaVencimiento();
    });

    this.formHeader.get('condicionPago').valueChanges.subscribe((value) => {
      this.fetchFechaVencimiento();
    });

    this.formHeader.get('descuentoPorcentaje').valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(value => {
        this.togglePorcentajeMontoValuesAndValidators(value, 'descuentoPorcentaje', 'descuentoMonto', true, this.cliente)
      }
      )
    this.formHeader.get('descuentoMonto').valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(value => {
        this.togglePorcentajeMontoValuesAndValidators(value, 'descuentoMonto', 'descuentoPorcentaje', false, this.cliente);
      }
      )

    // this.formHeader.get("vendedor").valueChanges.subscribe(vendedor => {
    //   this.handleVendedorChange(vendedor)
    // })
  }

  private createHeaderData() {
    const { cliente, sucursal } = this;
    this.log('createHeaderData - Cliente:', cliente);
    this.log('createHeaderData - Sucursal:', sucursal);
    this.log('createHeaderData - Vendedor:', this.formValue.vendedor);

    return {
      cliente,
      sucursal,
      vendedor: this.formValue.vendedor,
    };
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }

  show() {
    // this.formHeader.get('oc').setValue(0);
    this.CountListDocRef = null;
    this.documentRef = null;
    this.facturasAsociadas = []; // Limpiar facturas al mostrar formulario nuevo
    this.mostrarFacturasPopover = false; // Cerrar popover si está abierto
    // El datepicker puede marcar el control como "touched" al inicializar/limpiar.
    this.resetFechaVencControlState();
  }

  private resetFechaVencControlState() {
    const ctrl = this.formHeader && this.formHeader.get('fechaVenc');
    if (!ctrl) return;
    ctrl.markAsPristine();
    ctrl.markAsUntouched();
    ctrl.updateValueAndValidity({ emitEvent: false });
  }

  // Toggle del popover de facturas
  toggleFacturasPopover(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.mostrarFacturasPopover = !this.mostrarFacturasPopover;
  }

  // Cerrar popover de facturas
  cerrarFacturasPopover(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.mostrarFacturasPopover = false;
  }

  // Cerrar popover al hacer clic fuera
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.mostrarFacturasPopover && !target.closest('.facturas-badge-container')) {
      this.mostrarFacturasPopover = false;
    }
  }

  //CARGAR DATOS NOTA DE VENTA CABECERA
  Load(nv, mode) {
    this.log('Load - Iniciando carga de nota de venta:', nv, 'mode:', mode, 'cliente:', this.cliente);
    this.mode = mode;
    this.log('Load - Modo establecido:', this.mode);

    // Crear una copia profunda de la cabecera para evitar referencias compartidas
    this.NvCabecera = nv.cabecera ? JSON.parse(JSON.stringify(nv.cabecera)) : null;

    // RELLENAR INFORMACION DE NOTA VENTA
    const cabecera = this.NvCabecera;
    this.actualizarEstadoFormularioPorModo();

    if (!cabecera) {
      return;
    }

    this.nvFolio = nv.folio;

    this.cargarFacturasAsociadas(nv, cabecera);
    this.cargarOrdenCompra(cabecera);
    this.completarFormularioCabecera(cabecera);
    this.cargarClienteYSucursalParaModo(cabecera);
    // this.formHeader.get('').setValue(nv.vendedor_codigo)
  }

  private actualizarEstadoFormularioPorModo() {
    if (this.mode === 'SHOW') {
      this.formHeader.disable();
    } else {
      this.formHeader.enable();
    }
  }

  private cargarFacturasAsociadas(nv: any, cabecera: any) {
    let facturas = null;

    if (nv.folio_factura && Array.isArray(nv.folio_factura)) {
      facturas = nv.folio_factura;
    } else if (cabecera.folio_factura && Array.isArray(cabecera.folio_factura)) {
      facturas = cabecera.folio_factura;
    } else if (nv.cabecera && nv.cabecera.folio_factura && Array.isArray(nv.cabecera.folio_factura)) {
      facturas = nv.cabecera.folio_factura;
    }

    this.log('Load - Facturas encontradas:', facturas);
    this.log('Load - Estructura completa de nv:', JSON.stringify(nv, null, 2));

    if (facturas && facturas.length > 0) {
      this.facturasAsociadas = facturas.filter((f) => f != null && f != '0' && f != 0);
      this.log('Load - Facturas filtradas:', this.facturasAsociadas);
    } else {
      this.facturasAsociadas = [];
      this.log('Load - No se encontraron facturas asociadas');
    }
  }

  private cargarOrdenCompra(cabecera: any) {
    if (cabecera.ordenCompra && cabecera.ordenCompra.length > 0) {
      this.getCountListDocRef(cabecera.ordenCompra);
      this.modalDocsReferencias.load(cabecera.fechaDocumento, cabecera.ordenCompra);
    }
  }

  private completarFormularioCabecera(cabecera: any) {
    const rutuser = this.rutService.AgregarDV(cabecera.rutCliente);

    this.syncingDescuento = true;
    this.formHeader.get('fechaDoc').setValue(cabecera.fechaDocumento);
    this.formHeader.get('fechaVenc').setValue(cabecera.fechaVencimiento);
    this.formHeader.get('rutCliente').setValue(rutuser);
    this.formHeader.get('bodega').setValue(cabecera.codigoBodega);
    this.formHeader.get('sucursal').setValue(cabecera.codigoSucural);
    this.formHeader.get('vendedor').setValue(cabecera.codigoVendedor);
    this.formHeader.get('condicionPago').setValue(cabecera.condicionPago);
    this.formHeader.get('oc').setValue(cabecera.ordenCompra);
    this.formHeader.get('descuentoPorcentaje').setValue(cabecera.porcentajeDescuento);
    this.formHeader.get('descuentoMonto').setValue(cabecera.montoDescuento);
    this.formHeader.get('listaPrecios').setValue(cabecera.codigoListaPrecio);
    this.direccion_cliente = cabecera.direccion_codigo;
    this.syncingDescuento = false;
    this.descuentoDirty = false;

    setTimeout(() => {
      this.formHeader.get('unidad_negocio_codigo').setValue(cabecera.unidad_negocio_codigo);
      this.log('Load - Unidad de negocio establecida:', cabecera.unidad_negocio_codigo);
    }, 100);

    this.log('Load - Valores del formulario establecidos');
    this.log('Load - Condición de pago:', cabecera.condicionPago);
    this.log('Load - Vendedor:', cabecera.codigoVendedor);
    this.log('Load - Unidad de negocio:', cabecera.unidad_negocio_codigo);
  }

  private cargarClienteYSucursalParaModo(cabecera: any) {
    if (this.mode !== 'EDIT' && this.mode !== 'SHOW') {
      return;
    }

    this.loadClienteInfo(cabecera.rutCliente);

    this.cliente = {
      rut: cabecera.rutCliente,
      rutFormato: this.rutService.AgregarDV(cabecera.rutCliente),
      lista_precio_codigo: cabecera.codigoListaPrecio,
      descuento_maximo: cabecera.porcentajeDescuento,
    };

    const codigoDireccion = cabecera.direccion_codigo || cabecera.codigoSucural;
    this.fetchSucursalForEdit(cabecera.rutCliente, codigoDireccion);

    if (this.mode !== 'EDIT') {
      return;
    }

    setTimeout(() => {
      if (codigoDireccion) {
        this.log('Load - Cargando vendedores para dirección:', codigoDireccion);
        this.fetchVendedorForEdit(cabecera.rutCliente, codigoDireccion);
      }
    }, 1000);

    if (!cabecera.condicionPago) {
      return;
    }

    setTimeout(() => {
      this.log('Load - Estableciendo condición de pago:', cabecera.condicionPago);
      this.setCondicionPagoByCodigo(cabecera.condicionPago);
    }, 1500);
  }

  ObtenerDireccionCliente(rut_usuario, direccion) {
    this.log('onClienteSeleccionado', direccion);

    const inputParams = {
      cliente_proveedor_rut: rut_usuario,
      codigo: direccion,
      empresa_rut: this.rutEmpresa,
    };

    this.direccionService.GetDireccionCliente(inputParams, ({ mensajes, registros }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (registros) {
        this.optionsSucursal = registros.map((direccion) => ({
          value: direccion.codigo,
          label: direccion.direccion_completa,
          ...direccion,
        }));
        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('sucursal'), this.optionsSucursal);
      }
    });
  }

  onClienteSeleccionado({ data, origen }) {
    this.log('onClienteSeleccionado - Modo actual:', this.mode);

    // SOLO SE PODRA MODIFICAR EL DESCUENTO GLOBAL SI EL CLIENTE NO TIENE ASINGNADO UN DESCUENTO GLOBAL
    this.actualizarEstadoControlDescuentos(data.descuento_maximo);

    // En modo EDIT, no ejecutar la lógica de selección de cliente
    if (this.mode === 'EDIT') {
      this.log('onClienteSeleccionado - Modo EDIT detectado, saltando ejecución');
      return;
    }

    if (this.cliente && data.rut == this.cliente.rut) {
      this.log('onClienteSeleccionado - Cliente seleccionado es el mismo, saltando ejecución');
      return;
    }
    this.log('onClienteSeleccionado - Ejecutando lógica normal');
    this.cleanClientDataAndRelated();

    const descuentoMaximoCliente = data && data.descuento_maximo ? data.descuento_maximo : 0;
    const descuentoGlobalNV = this.NvCabecera && this.NvCabecera.porcentajeDescuento ? this.NvCabecera.porcentajeDescuento : 0;
    const tieneDescuentoMaximo = descuentoMaximoCliente > 0;

    this.cliente = data;
    this.syncingDescuento = true;
    this.cliente.rutFormato = this.rutService.AgregarDV(this.cliente.rut);
    this.formHeader.get('rutCliente').setValue(this.cliente.rutFormato);
    this.formHeader.get('listaPrecios').setValue(this.cliente.lista_precio_codigo);
    this.formHeader.get('descuentoPorcentaje').setValue(tieneDescuentoMaximo ? descuentoMaximoCliente : descuentoGlobalNV);
    this.syncingDescuento = false;
    this.descuentoDirty = false;

    this.onHeaderDataChange.emit(this.createHeaderData());

    // En modo ADD, cargar todas las sucursales del cliente
    this.fetchSucursal(this.cliente.rut, null);
  }

  cleanClientDataAndRelated() {
    this.log('cleanClientDataAndRelated - Modo actual:', this.mode);

    this.cliente = null;

    // En modo EDIT, no limpiar las opciones de sucursal porque ya las cargamos correctamente
    if (this.mode !== 'EDIT') {
      this.log('cleanClientDataAndRelated - Limpiando opciones de sucursal (modo no EDIT)');
      this.optionsSucursal = [];
      this.formHeader.get('sucursal').setValue(null);
      this.formHeader.get('sucursal').markAsPristine();
      this.formHeader.get('sucursal').markAsUntouched();
    } else {
      this.log('cleanClientDataAndRelated - Modo EDIT detectado, preservando opciones de sucursal');
    }

    this.formHeader.get('rutCliente').markAsPristine();
    this.formHeader.get('rutCliente').markAsUntouched();

    // En modo EDIT, no limpiar el vendedor porque ya lo establecimos
    if (this.mode !== 'EDIT') {
      this.log('cleanClientDataAndRelated - Limpiando vendedor (modo no EDIT)');
      this.formHeader.get('vendedor').setValue(null);
      this.formHeader.get('vendedor').markAsPristine();
      this.formHeader.get('vendedor').markAsUntouched();
      this.optionsVendedor = [];
    } else {
      this.log('cleanClientDataAndRelated - Modo EDIT detectado, preservando vendedor');
    }

    // En modo EDIT, no limpiar la sucursal porque ya la establecimos
    if (this.mode !== 'EDIT') {
      this.sucursal = null;
    }
  }

  onClienteNoEncontrado() {
    this.log('onClienteNoEncontrado');
    this.cliente = null;
    this.cleanClientDataAndRelated();
    this.onHeaderDataChange.emit(this.createHeaderData());
  }

  private actualizarEstadoControlDescuentos(descuentoMaximo: number) {
    if (descuentoMaximo > 0) {
      this.formHeader.get('descuentoPorcentaje').disable();
      this.formHeader.get('descuentoMonto').disable();
    } else if (this.mode != 'SHOW') {
      this.formHeader.get('descuentoPorcentaje').enable();
      this.formHeader.get('descuentoMonto').enable();
    }
  }

  private fetchSucursal(cliente_proveedor_rut, direccion) {
    const inputParams = {
      cliente_proveedor_rut: cliente_proveedor_rut,
      codigo: direccion, // null para obtener todas las sucursales
      empresa_rut: this.rutEmpresa,
    };

    this.log('fetchSucursal - Cargando sucursales para cliente:', cliente_proveedor_rut, 'dirección:', direccion);

    this.direccionService.GetDireccionCliente(inputParams, ({ mensajes, registros }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (registros) {
        this.log('fetchSucursal - Sucursales encontradas:', registros.length);

        this.optionsSucursal = registros.map((direccion) => ({
          value: direccion.codigo,
          label: direccion.direccion_completa,
          ...direccion,
        }));

        // Si no hay dirección específica, seleccionar la primera por defecto
        if (!direccion) {
          this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('sucursal'), this.optionsSucursal);
        }

        this.fetchFechaVencimiento();
      }
    });
  }

  private fetchSucursalForEdit(cliente_proveedor_rut, direccion_codigo) {
    this.log('fetchSucursalForEdit - Iniciando carga de sucursales para edición');

    const inputParams = {
      cliente_proveedor_rut: cliente_proveedor_rut,
      codigo: null, // null para obtener todas las sucursales
      empresa_rut: this.rutEmpresa,
    };

    this.direccionService.GetDireccionCliente(inputParams, ({ mensajes, registros }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (registros) {
        this.log('fetchSucursalForEdit - Sucursales cargadas:', registros.length);

        // Crear las opciones con todas las sucursales
        this.optionsSucursal = registros.map((direccion) => ({
          value: direccion.codigo,
          label: direccion.direccion_completa,
          ...direccion,
        }));

        // Encontrar y seleccionar la sucursal que coincida con direccion_codigo
        this.sucursal = this.optionsSucursal.find((s) => s.value === direccion_codigo);
        this.log('fetchSucursalForEdit - Sucursal encontrada:', this.sucursal);
        this.log('fetchSucursalForEdit - Información completa de sucursal:', JSON.stringify(this.sucursal));

        // Establecer el valor en el formulario
        this.formHeader.get('sucursal').setValue(direccion_codigo);

        // Establecer la condición de pago basada en la sucursal
        if (this.sucursal && this.sucursal.condicion_pago_codigo) {
          this.setCondicionPagoByCodigo(this.sucursal.condicion_pago_codigo);
        }

        // Emitir el cambio para que se actualicen los campos de dirección
        this.onHeaderDataChange.emit(this.createHeaderData());

        this.fetchFechaVencimiento();
      }
    });
  }

  private handleDireccionChange(value) {
    this.sucursal = this.optionsSucursal.filter((p) => p.value === value)[0];
    this.onHeaderDataChange.emit(this.createHeaderData());
    if (this.cliente && this.sucursal) {
      this.fetchVendedor(this.cliente.rut, this.sucursal.codigo);
      // this.fetchFechaVencimiento()
      this.setCondicionPagoByCodigo(this.sucursal.condicion_pago_codigo);
    }
  }

  private fetchVendedor(rut, codigo_direccion) {
    const inputParams: any = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalEmpresa, // https://trello.com/c/uVoPe50E/166-01-nota-de-venta-linea-de-negocio. QA.- 2
      rutCliente: rut,
      direccionCodigo: codigo_direccion,
    };

    this.log('load vendedor input params', JSON.stringify(inputParams));

    if (this.NvCabecera) {
      this.vendedorRubroClienteService.GetAllVendedores(inputParams, ({ registros }) => {
        this.optionsVendedor = registros.map((vendedor) => ({
          value: vendedor.codigo,
          label: vendedor.nombre,
          ...vendedor,
        }));

        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor);
        this.formHeader.get('vendedor').setValue(this.NvCabecera.codigoVendedor);
      });
    } else {
      this.vendedorRubroClienteService.GetByCliente(inputParams, ({ registros }) => {
        this.optionsVendedor = registros.map((vendedor) => ({
          value: vendedor.vendedor_codigo,
          label: vendedor.nombreVendedor,
          ...vendedor,
        }));

        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor);
      });
    }
  }

  private loadClienteInfo(rutCliente: number) {
    this.log('loadClienteInfo - Cargando información del cliente:', rutCliente);

    // Usar el servicio de cliente para obtener la información completa
    const inputParams = {
      entidad: {
        rut: rutCliente,
        empresa_rut: this.rutEmpresa,
      },
    };

    // Usar el servicio de cliente que ya está inyectado
    this.clienteProveedorService.obtenerSegunId(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (respuesta) {
        this.log('loadClienteInfo - Cliente encontrado:', respuesta);
        const { nombre, razon_social, lista_precio_codigo, descuento_maximo } = respuesta;

        this.cliente = {
          ...this.cliente,
          nombre,
          razon_social: razon_social || nombre, // Usar razon_social si existe, sino usar nombre
          lista_precio_codigo,
          descuento_maximo,
          ...respuesta,
        };

        this.actualizarEstadoControlDescuentos(descuento_maximo);

        this.log('loadClienteInfo - Cliente actualizado:', this.cliente);
      } else {
        this.log('loadClienteInfo - No se encontró información del cliente');
      }
    });
  }

  private fetchVendedorForEdit(rut, codigo_direccion) {
    this.log('fetchVendedorForEdit - Iniciando carga de vendedores para edición');

    const inputParams: any = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalEmpresa,
      rutCliente: rut,
      direccionCodigo: codigo_direccion,
    };

    this.log('fetchVendedorForEdit - Parámetros:', JSON.stringify(inputParams));

    this.vendedorRubroClienteService.GetAllVendedores(inputParams, ({ registros }) => {
      this.log('fetchVendedorForEdit - Vendedores cargados:', registros ? registros.length : 0);

      if (registros && registros.length > 0) {
        // Log del primer vendedor para ver la estructura
        this.log('fetchVendedorForEdit - Estructura del primer vendedor:', JSON.stringify(registros[0]));

        this.optionsVendedor = registros.map((vendedor) => ({
          value: vendedor.codigo,
          label: vendedor.nombre,
          ...vendedor,
        }));

        this.log('fetchVendedorForEdit - Opciones de vendedor creadas:', this.optionsVendedor.length);
        this.log('fetchVendedorForEdit - Primera opción de vendedor:', JSON.stringify(this.optionsVendedor[0]));
        this.log('fetchVendedorForEdit - Buscando vendedor con código:', this.NvCabecera && this.NvCabecera.codigoVendedor);

        // Si estamos en modo edición y ya tenemos un vendedor seleccionado, establecerlo
        if (this.NvCabecera && this.NvCabecera.codigoVendedor) {
          const vendedorSeleccionado = this.optionsVendedor.find((v) => v.value === this.NvCabecera.codigoVendedor);
          if (vendedorSeleccionado) {
            this.log('fetchVendedorForEdit - Vendedor encontrado:', vendedorSeleccionado);
            this.formHeader.get('vendedor').setValue(this.NvCabecera.codigoVendedor);
          } else {
            this.log('fetchVendedorForEdit - Vendedor no encontrado, usando primero disponible');
            this.log(
              'fetchVendedorForEdit - Códigos disponibles:',
              this.optionsVendedor.map((v) => v.value)
            );
            this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor);
          }
        } else {
          this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor);
        }
      } else {
        this.log('fetchVendedorForEdit - No se encontraron vendedores para esta dirección');
        this.optionsVendedor = [];
      }
    });
  }

  setCondicionPagoByCodigo(condicion_pago_codigo) {
    if (!condicion_pago_codigo) {
      this.log('setCondicionPagoByCodigo - Código de condición de pago no proporcionado');
      return;
    }

    this.log('setCondicionPagoByCodigo - Buscando condición de pago con código:', condicion_pago_codigo);
    this.log('setCondicionPagoByCodigo - Opciones disponibles:', this.optionsCondicionPago);

    const _condicionPago = this.optionsCondicionPago.filter((p) => p.value === condicion_pago_codigo);
    if (_condicionPago && _condicionPago.length > 0) {
      this.log('setCondicionPagoByCodigo - Condición de pago encontrada:', _condicionPago[0]);
      this.formHeader.get('condicionPago').setValue(_condicionPago[0].value);
    } else {
      this.log('setCondicionPagoByCodigo - No se encontró condición de pago con código:', condicion_pago_codigo);
    }
  }

  private fetchFechaVencimiento() {
    // private fetchFechaVencimiento = () => {
    // const { fechaDoc, sucursal } = this.formHeader.value;
    const fechaDoc = this.formValue.fechaDoc;
    const sucursal = this.formValue.sucursal;

    if (!fechaDoc || !sucursal)
      // || !this.formHeader.get("condicionPago")
      return;

    const sucursalSeleccionada = this.optionsSucursal.filter((p) => p.value === this.formValue.sucursal)[0];
    if (!sucursalSeleccionada) return;

    const inputParams: IFechaVencimientoQueryParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      cliente_proveedor_rut: 0,
      // direccion_codigo: this.headerData.clienteSeleccionado.codigo_direccion,
      // direccion_codigo: 0,
      direccion_codigo: sucursalSeleccionada.codigo,
      fecha_documento: this.formValue.fechaDoc,
      // condicion_pago_codigo: sucursalSeleccionada.condicion_pago_codigo,
      condicion_pago_codigo: this.formValue.condicionPago,
    };

    this.log('fetchFechaVencimiento', JSON.stringify(inputParams));
    this.documentoService.ObtenerFechaVencimiento(inputParams, ({ mensajes, respuesta }) => {
      this.formHeader.get('fechaVenc').setValue(respuesta.fecha_vencimiento);
    });
  }

  public getHeaderData() {
    if (this.cliente) {
      // direccion_codigo corresponde a la dirección del cliente seleccionada.
      // codigoSucural corresponde a la sucursal del ERP (no confundir con el código de dirección).
      const direccionCliente = this.formValue.sucursal;
      return {
        unidad_negocio_codigo: this.formValidatorsService.obtenerValorFormHeader(this.formHeader, 'unidad_negocio_codigo'),
        fechaDocumento: this.formValue.fechaDoc,
        fechaVencimiento: this.formValue.fechaVenc,
        codigoBodega: this.formValue.bodega,
        rutEmisor: this.rutEmpresa,
        rutCliente: this.cliente.rut, //this.formHeader.get('rutCliente').value,
        codigoSucural: this.sucursalEmpresa,
        direccion_codigo: direccionCliente,
        condicionPago: this.formValue.condicionPago,
        ordenCompra: this.documentRef,
        porcentajeDescuento: this.formValue.descuentoPorcentaje ? this.formValue.descuentoPorcentaje : 0,
        montoDescuento: this.formValue.descuentoMonto ? this.formValue.descuentoMonto : 0,
        // porcentajeDescuento: this.formHeader.get('descuento').value ? this.formHeader.get('descuento').value : 0,
        codigoVendedor: this.formValue.vendedor,
        codigoListaPrecio: this.cliente ? this.cliente.lista_precio_codigo : null,
        tipoDocumentoDTE: 2, // NOTA-VENTA // TODO: De dónde viene?
      };
    } else {
      var a: any = [];
      return a;
    }
  }

  public validate() {
    const unidad_negocio_codigo_state = this.formHeader.get('unidad_negocio_codigo').enabled;
    this.formHeader.get('unidad_negocio_codigo').enable();

    // Add/Remove unidad_negocio_codigo validators
    if (this.permiteUnidadNegocio) {
      this.formHeader.get('unidad_negocio_codigo').setValidators([Validators.required]);
    } else {
      this.formHeader.get('unidad_negocio_codigo').setValidators([]);
    }
    this.formHeader.get('unidad_negocio_codigo').updateValueAndValidity();

    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!unidad_negocio_codigo_state) this.formHeader.get('unidad_negocio_codigo').disable();

    if (!this.formHeader.valid) {
      const invalidControls = Object.entries(this.formHeader.controls)
        .filter(([_, control]) => control.invalid)
        .map(([name, control]) => ({
          control: name,
          errors: control.errors,
          disabled: control.disabled,
          value: control.value,
        }));
      console.warn('Cabecera inválida', invalidControls);
    }
    return this.formHeader.valid || this.formHeader.disabled;
  }

  // ESTE METODO ACTUALIZA
  // LA NOTA DE VENTA COMPLETA CON EL DESCUENTO GLOBAL APLICANDOLO
  aplicarDescuentoGlobal() {
    if (!this.cliente) {
      return;
    }

    const porcentaje = this.formHeader.get('descuentoPorcentaje').value;
    const monto = this.formHeader.get('descuentoMonto').value;

    if (porcentaje && monto) {
      this.toastrService.warning('Solo puede ingresar porcentaje o monto de descuento, no ambos.');
      return;
    }

    const porcentajeValue = porcentaje ? Number(porcentaje) : 0;
    const montoValue = monto ? Number(monto) : 0;

    // Validar que ninguno de los valores sea negativo
    if (porcentajeValue < 0 || montoValue < 0) {
      this.toastrService.warning('El porcentaje y el monto no pueden ser negativos.');
      return;
    }

    const payload = {
      porcentajeDescuento: porcentajeValue,
      montoDescuento: montoValue,
    };

    this.onApplyGlobalDiscount.emit(payload);
  }

  resetDescuentoDirty() {
    this.syncingDescuento = true;
    this.descuentoDirty = false;
    this.syncingDescuento = false;
  }

  disableContent() {
    // this.enableContent = false;
    this.formHeader.disable();
    if (this.mode != 'SHOW' && this.cliente.descuento_maximo == 0) {
      this.formHeader.get('descuentoPorcentaje').enable();
      this.formHeader.get('descuentoMonto').enable();
    }
  }

  clearContent() {
    this.modalDocsReferencias.clearData();
    this.NvCabecera = null;
    this.CountListDocRef = null;
    this.documentRef = null;
    this.enableContent = true;
    this.cliente = null;
    this.sucursal = null;
    this.direccion_cliente = null;
    this.nvFolio = 0;
    this.optionsSucursal = [];
    this.optionsVendedor = [];
    this.mode = 'ADD';
    this.formValidatorsService.reset(this.formHeader);
    this.datePickerFechaVencimiento.clearDate();
    this.formHeader.enable();

    const now = this.datesService.CurrentDateToShortTimeString();
    // this.formHeader.get('fechaDoc').setValue(now)
    this.formHeader.get('unidad_negocio_codigo').setValue(null);
    this.formHeader.get('fechaVenc').setValue(null);
    this.formHeader.get('bodega').setValue(null);
    this.formHeader.get('unidad_negocio_codigo').setValue(null);
    this.formHeader.get('rutCliente').setValue(null);
    this.formHeader.get('sucursal').setValue(null);
    this.formHeader.get('condicionPago').setValue(null);
    this.formHeader.get('oc').setValue(null);
    this.formHeader.get('descuentoPorcentaje').setValue(null);
    this.formHeader.get('descuentoMonto').setValue(null);
    // this.formHeader.get('descuento').setValue(null);
    this.formHeader.get('vendedor').setValue(null);
    this.formHeader.get('listaPrecios').setValue(null);
    // this.formValidatorsService.reset(this.formHeader);
    this.formHeader.get('fechaDoc').setValue(now);

    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega);
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('condicionPago'), this.optionsCondicionPago);

    this.enableUnidadNegocio();
    // Asegurar que no se muestre el mensaje al entrar a "Agregar"
    this.resetFechaVencControlState();
  }

  disableUnidadNegocio(unidad_negocio_codigo: number | null) {
    // this.log('bloquear unidad negocio', unidad_negocio_codigo, this.formHeader.get('unidad_negocio_codigo').value)
    if (unidad_negocio_codigo) this.formHeader.get('unidad_negocio_codigo').setValue(unidad_negocio_codigo);
    this.formHeader.get('unidad_negocio_codigo').disable();
  }

  enableUnidadNegocio() {
    this.formHeader.get('unidad_negocio_codigo').enable();
  }

  private togglePorcentajeMontoValuesAndValidators(value, currentFormControlName, previousFormControlName, isPorcentaje, cliente = null) {
    if (value === null) return;
    if (value) {
      const monto = Number(value);
      if (!this.syncingDescuento && monto >= 0) {
        this.descuentoDirty = true;
      }
      // remove validators
      this.formHeader.get(previousFormControlName).setValidators(null);
      this.formHeader.get(previousFormControlName).setValue(null);
      this.formHeader.get(previousFormControlName).updateValueAndValidity();

      // set validator
      const validators = [Validators.min(0)];
      if (isPorcentaje) {
        if (cliente) {
          const { descuento_maximo } = cliente;
          if (descuento_maximo > 0) validators.push(Validators.max(descuento_maximo));
          else validators.push(Validators.max(99.9999));
        } else validators.push(Validators.max(99.9999));
      }
      this.formHeader.get(currentFormControlName).setValidators(validators);
      this.formHeader.get(currentFormControlName).updateValueAndValidity();
    } else {
      if (!this.syncingDescuento && !this.formValue[currentFormControlName]) {
        this.descuentoDirty = false;
      }
    }
  }
}
